<template>
  <a-row>
    <h3 class="stats-users-by-roles">
      {{ 'stats-users-by-roles.title' | globalize }}
    </h3>
    <template v-if="!error">
      <a-col
        span="4"
        :key="value.role"
        v-for="value in data"
      >
        <a-statistic
          :title="value.role"
          :value="value.roleCount"
          style="margin-right: 50px"
        />
      </a-col>
    </template>
    <a-col v-if="error">
      <a-alert
        :message="error"
        type="error" />
    </a-col>
  </a-row>
</template>

<script>
import ARow from 'ant-design-vue/lib/row'
import AAlert from 'ant-design-vue/lib/alert'
import ACol from 'ant-design-vue/lib/col'
import AStatistic from 'ant-design-vue/lib/statistic'

export default {
  name: 'dashboard',
  components: {
    AStatistic,
    ARow,
    ACol,
    AAlert,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    error: {
      type: String,
      default: () => null,
    },
  },
}
</script>

<style scoped lang="scss" >
  @import '~ant-design-vue/lib/grid/style/index.css';
  @import '~ant-design-vue/lib/statistic/style/index.css';
  @import '~ant-design-vue/lib/alert/style/index.css';

  .stats-users-by-roles {
    margin-bottom: 1em;
  }
</style>
